/**
 * Pacis Students PA rating card — source: STUDENTS PA RATING CARD.docx
 */

export const PA_PRODUCT_CODE = 'PA_STUDENT';

export const PA_COURSE_DURATIONS = [
  { code: '1_YEAR', label: '1 Year Course' },
  { code: '6_MONTH', label: '6 Month Course' },
  { code: '3_MONTH', label: '3 Month Course' },
];

const BENEFIT_DEFS = [
  { code: 'DEATH', label: 'Accidental death' },
  { code: 'PTD', label: 'Permanent total disability' },
  { code: 'MEDICAL', label: 'Accident medical expenses' },
  { code: 'ARTIFICIAL', label: 'Artificial appliances' },
  { code: 'DENTAL', label: 'Dental expenses' },
  { code: 'OPTICAL', label: 'Optical appliances' },
  { code: 'FUNERAL', label: 'Funeral expenses' },
];

const OPTION_LIMITS = {
  OPTION_1: {
    DEATH: 200000, PTD: 200000, MEDICAL: 100000, ARTIFICIAL: 20000, DENTAL: 20000, OPTICAL: 20000, FUNERAL: 40000,
  },
  OPTION_2: {
    DEATH: 150000, PTD: 150000, MEDICAL: 80000, ARTIFICIAL: 20000, DENTAL: 20000, OPTICAL: 20000, FUNERAL: 40000,
  },
  OPTION_3: {
    DEATH: 100000, PTD: 100000, MEDICAL: 50000, ARTIFICIAL: 20000, DENTAL: 20000, OPTICAL: 20000, FUNERAL: 20000,
  },
};

function buildOption(code, name) {
  return {
    code,
    name,
    benefits: BENEFIT_DEFS.map((b) => ({
      code: b.code,
      label: b.label,
      limit: OPTION_LIMITS[code][b.code],
    })),
  };
}

export const PA_OPTIONS = [
  buildOption('OPTION_1', 'Option 1'),
  buildOption('OPTION_2', 'Option 2'),
  buildOption('OPTION_3', 'Option 3'),
];

/** Premium matrix: courseDuration -> optionCode -> KES (tax-inclusive; GIS resolves levies). */
export const PA_PREMIUM_MATRIX = {
  '1_YEAR': { OPTION_1: 1240, OPTION_2: 950, OPTION_3: 650 },
  '6_MONTH': { OPTION_1: 750, OPTION_2: 570, OPTION_3: 400 },
  '3_MONTH': { OPTION_1: 600, OPTION_2: 500, OPTION_3: 350 },
};

export function getPaPremium(courseDuration, optionCode) {
  const row = PA_PREMIUM_MATRIX[courseDuration];
  if (!row) return 0;
  return row[optionCode] ?? 0;
}

/** Resolve tax-inclusive premium from live rate card API, with static matrix fallback. */
export function getPaPremiumFromRateCard(rateCard, courseDuration, optionCode) {
  const premiums = rateCard?.premiums;
  if (Array.isArray(premiums) && courseDuration && optionCode) {
    const row = premiums.find((p) => p.courseDuration === courseDuration);
    const amount = row?.[optionCode];
    if (amount != null && !Number.isNaN(Number(amount))) {
      return Number(amount);
    }
  }
  return getPaPremium(courseDuration, optionCode);
}

export function buildRateCardPayload() {
  return {
    productCode: PA_PRODUCT_CODE,
    productName: 'Students Personal Accident',
    currency: 'KES',
    options: PA_OPTIONS,
    premiums: PA_COURSE_DURATIONS.map((d) => ({
      courseDuration: d.code,
      label: d.label,
      OPTION_1: PA_PREMIUM_MATRIX[d.code].OPTION_1,
      OPTION_2: PA_PREMIUM_MATRIX[d.code].OPTION_2,
      OPTION_3: PA_PREMIUM_MATRIX[d.code].OPTION_3,
    })),
  };
}
